const items = ['শুভ বিবাহ', 'শুভ নিমন্ত্রণ', 'আশীর্বাদ', 'শ্রীশ্রী প্রজাপতয়ে নমঃ'];

export default function Marquee() {
  return (
    <section className="marquee-band" data-testid="marquee">
      <div className="marquee-track">
        {[...items, ...items].map((t, i) => (
          <span key={i} className="marquee-item font-display">
            {t}
            <svg width="11" height="11" viewBox="0 0 10 10">
              <path d="M5 0 L10 5 L5 10 L0 5 Z" fill="#DDBE76" />
            </svg>
          </span>
        ))}
      </div>
    </section>
  );
}
